<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { Avatar, AvatarFallback, AvatarImage } from '@ui/components/avatar/index';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';
  import { cn } from '@ui/utils/utils';

  import { avatarVariant } from '.';
  import type { AvatarVariants } from '.';

  interface Props {
    class?: HTMLAttributes['class'];
    size?: AvatarVariants['size'];
    src?: string | null;
    tooltipText?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    size: 'base',
  });
</script>

<template>
  <Tooltip :disabled="!tooltipText">
    <TooltipTrigger as-child>
      <Avatar
        v-bind="$attrs"
        :class="
          cn(
            avatarVariant({ size }),
            'transition-all transition-duration-300 rounded bg-transparent!',
            !src && 'border',
            props.class,
          )
        "
      >
        <AvatarImage
          :src="src ?? ''"
          alt="@stuut"
          class="object-contain! transition-all transition-duration-300"
        />
        <AvatarFallback class="text-primary font-semibold text-base">
          <i class="fa fa-building" />
        </AvatarFallback>
      </Avatar>
    </TooltipTrigger>

    <TooltipContent>
      <p>
        {{ tooltipText }}
      </p>
    </TooltipContent>
  </Tooltip>
</template>
